import { eMoneyMeta } from "../../data/DataMetatags";
import NextHead from "../../components/Seo/NextHead";
import Layout from "../../components/Layout";
import BreadcrumbComponent from "../../components/UserInterface/BreadcrumbComponent";
import { eMoneyBreadcrumb } from "../../data/DataBreadcrumb";
import { defBreadcrumb } from "../../data/DataBreadcrumb";
import {
  ElectronicMoneyAccordion,
  ElectronicMoneyHeading,
  ElectronicMoneyWrapper,
} from "src/views/cara-pembayaran/electronic-money";

const ElectronicMoney = (props) => {
  const { breadcrumb, eMoneyBreadcrumb, title, description, path } = props;

  return (
    <Layout>
      <NextHead
        title={title}
        description={description}
        url={path}
        breadcrumb={breadcrumb}
      />
      <BreadcrumbComponent items={eMoneyBreadcrumb} />
      <ElectronicMoneyWrapper>
        <ElectronicMoneyHeading />
        <ElectronicMoneyAccordion />
      </ElectronicMoneyWrapper>
    </Layout>
  );
};

export const getStaticProps = () => {
  const { title, description, path } = eMoneyMeta;

  const breadcrumb = [
    ...defBreadcrumb,
    {
      "@type": "ListItem",
      position: "2",
      item: {
        "@id": process.env.baseUrl + path,
        name: title,
      },
    },
  ];
  return {
    props: {
      breadcrumb,
      eMoneyBreadcrumb,
      title,
      description,
      path,
    },
  };
};

export default ElectronicMoney;
